import { Link } from 'react-router-dom';
import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function BlogHero() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 24, duration: 800 });

  return (
    <section
      ref={ref}
      className="relative w-full bg-brand-black overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=elegant-fashion-magazine-editorial-spread-luxury-haute-couture-accessories-gold-jewelry-silk-fabric-dark-background-soft-spotlight-grain-texture-cinematic-editorial-photography-warm-tones-landscape-orientation&width=1920&height=1080&seq=102&orientation=landscape"
          alt="Blog de Tendencias Anthony Sánchez Couture"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-brand-black/60 via-brand-black/40 to-brand-black/80" />
      </div>

      <div className="relative z-10 px-6 lg:px-[7%] pt-40 pb-20 md:pt-48 md:pb-28">
        <div className="max-w-3xl" style={style}>
          <span className="font-sans text-brand-gray-300 text-[11px] tracking-[0.2em] uppercase font-medium">
            Blog de Tendencias
          </span>
          <h1 className="font-serif text-white text-[clamp(2.5rem,5vw,4rem)] font-semibold leading-[1.1] mt-5">
            Estilo, Arte
            <br />
            <span className="italic text-brand-gray-200">y Tendencias</span>
          </h1>
          <p className="font-sans text-brand-gray-300 text-base md:text-lg leading-[1.8] mt-6 max-w-xl">
            Reflexiones sobre moda, técnicas artesanales y el arte de vestir con
            intención. Desde el atelier de Barcelona hacia el mundo.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Link
              to="/blog#articulos"
              className="inline-flex items-center gap-2 bg-white text-brand-black font-sans text-[13px] tracking-widest uppercase px-7 py-3.5 rounded-md hover:bg-brand-gray-50 transition-colors duration-300 whitespace-nowrap"
            >
              Explorar artículos
              <i className="ri-arrow-down-line" />
            </Link>
            <Link
              to="/alta-costura"
              className="inline-flex items-center gap-2 border border-white/30 text-white font-sans text-[13px] tracking-widest uppercase px-7 py-3.5 rounded-md hover:bg-white/10 transition-colors duration-300 whitespace-nowrap"
            >
              Alta Costura
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}